module.exports = __webpack_public_path__ + "prod/20260124143402/img/ecology.1a964161.png";